import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { myCompanyAccountInitStepDeclaration } from "./Steps/MyCompanyAccountInitStep";

export const myCompanyAccountStartupFlow = new FlowDefinition("MyCompanyAccountFlow");

myCompanyAccountStartupFlow.addStep(myCompanyAccountInitStepDeclaration);

myCompanyAccountStartupFlow.setStartStep("MyCompanyAccountInit_Step");
